"use client"
import { useRef } from "react"
import Button from "../Button/Button"
import Title from "../Title/Title"

function Hero() {
  const sectionRef = useRef<HTMLElement>(null)

  return (
    <section
      ref={sectionRef}
      className="relative w-full h-screen overflow-hidden flex bg-cover bg-center px-6 xl:px-16 3xl:px-24"
      style={{
        pointerEvents: "auto",
        backgroundImage: `url('/video-poster.png')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Video Background Implementation */}
      <video
        src="/videos/cs-vid.mp4"
        autoPlay
        loop
        playsInline
        preload="none"
        muted
        aria-hidden="true"
        tabIndex={-1}
        width={1920}
        height={1080}
        className="absolute inset-0 w-full h-full object-cover"
        poster="/video-poster.png"
      />

      {/* Background Overlay for better text readability */}
      <div className="absolute inset-0 bg-black bg-opacity-30 z-[1]"></div>

      <div
        className="xl:w-3/4 3xl:w-full relative z-[2] flex flex-col justify-end mb-24 w-full text-white text-left"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <Title
          title="Security is Invisible.Until it's Not."
          className="text-[48px] 2xl:text-[120px] 3xl:text-[196px]  uppercase font-semibold"
          type="h1"
        />
        <p className="xl:text-[24px] 2xl:text-[34px] my-4 max-w-[830px] uppercase font-semibold">
          We design, build, and advise with precision. For critical
          infrastructure, government, and enterprise.
        </p>
        <div className="flex flex-col xl:flex-row gap-4 xl:gap-16 mt-8 items-center">
          <Button
            title="FREE CONSULTATION"
            type="three"
            url="/contact"
            icon={true}
          />
          {/* <Button
            title="Download the Brochure"
            type="two"
            url="/contact"
            icon={false}
          /> */}
        </div>
      </div>

      {/* Scroll Down Text */}
      <div className="absolute hidden xl:flex gap-4 items-center font-semibold right-24 bottom-24 z-[3] text-white text-[34px] font-oswald uppercase text-[--color-gray] opacity-80 tracking-wider">
        <span>scroll down</span>
        <svg
          width="81"
          height="80"
          viewBox="0 0 81 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_42_68)" className="animate-spin-slow">
            <path
              d="M70.6105 44.0891C68.9975 56.2575 60.2816 66.1762 48.7782 69.572C47.2784 70.0248 45.7361 70.3502 44.1514 70.5483C43.0194 70.7039 41.8734 70.803 40.7131 70.8171C37.9399 74.0007 34.6714 76.7598 30.9784 78.9529C33.8932 79.6463 36.9211 80 40.0481 80C45.3258 80 50.3771 78.9813 54.9897 77.0994C56.8999 76.3353 58.7393 75.4298 60.4938 74.3686C67.9646 69.9257 73.8649 63.1058 77.1475 54.9558C75.5628 50.9798 73.3413 47.3152 70.6105 44.0891ZM77.1475 25.0584C76.3976 23.1341 75.4779 21.2947 74.4167 19.5401C69.9597 12.0693 63.1397 6.16908 54.9897 2.9006C51.0138 4.49947 47.3633 6.70676 44.1514 9.45172C56.3056 11.0506 66.2384 19.7524 69.6201 31.2699C70.0729 32.7697 70.3983 34.3261 70.6105 35.9109C70.7662 37.0287 70.8511 38.1747 70.8652 39.335C74.063 42.1082 76.8221 45.3767 79.001 49.0697C79.6944 46.1549 80.0481 43.1128 80.0481 40C80.0481 34.7223 79.0294 29.671 77.1475 25.0584ZM40.0481 0C34.7704 0 29.7191 1.01875 25.1065 2.9006C23.1963 3.66466 21.3569 4.57022 19.6024 5.63141C12.1316 10.0743 6.23133 16.8942 2.9487 25.0584C4.53342 29.0343 6.769 32.699 9.48566 35.9109C11.0987 23.7425 19.8005 13.8097 31.318 10.428C32.8178 9.97524 34.3601 9.64981 35.9448 9.45172C37.0767 9.29607 38.2228 9.19703 39.3831 9.18288C42.1563 5.98514 45.4248 3.22603 49.1178 1.04705C46.203 0.353732 43.1751 0 40.0481 0ZM10.4761 48.7301C10.0233 47.2303 9.6979 45.6739 9.48566 44.0891C9.33002 42.9572 9.24512 41.8111 9.23098 40.6509C6.04739 37.8918 3.28828 34.6233 1.09514 30.9303C0.401828 33.8451 0.0480957 36.8872 0.0480957 40C0.0480957 45.2918 1.08099 50.329 2.9487 54.9558C3.71276 56.8659 4.61831 58.7053 5.67951 60.4599C10.1365 67.9307 16.9565 73.8309 25.1065 77.0994C29.0824 75.5005 32.7329 73.2791 35.9448 70.5483C23.7764 68.9494 13.8578 60.2335 10.4761 48.7301Z"
              fill="#EF5527"
              className="rotate"
            />
            <path
              d="M56.0793 24.365V32.4442L40.0482 42.4195L24.0029 32.4442V24.365L40.0482 34.3402L56.0793 24.365Z"
              fill="#EF5527"
              className="updown"
            />
            <path
              d="M56.0793 37.5804V45.6597L40.0482 55.6349L24.0029 45.6597V37.5804L40.0482 47.5557L56.0793 37.5804Z"
              fill="#EF5527"
              className="updown"
            />
          </g>
          <defs>
            <clipPath id="clip0_42_68">
              <rect
                width="80"
                height="80"
                fill="white"
                transform="translate(0.0480957)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </section>
  )
}

export default Hero
